import { Injectable, inject } from '@angular/core';
import { Observable } from 'rxjs';
import { ApiService } from '../../services/api.service';
import { ApiResponse } from '../../shared/types';

export interface CompanyAdmin {
  id: string;
  name: string;
  email: string;
  contact_number: string | null;
  role: string;
  status: boolean;
  company_id: string | null;
  emp_id?: string | null;
  picture_url?: string | null;
  is_company_owner: boolean;
  created_at?: string;
  updated_at?: string;
}

export interface InviteCompanyAdminPayload {
  name: string;
  email: string;
  contact_number: string;
  password: string;
}

@Injectable({ providedIn: 'root' })
export class CompanyAdminService {
  private readonly apiService = inject(ApiService);
  private readonly basePath = 'user/company/admins';

  listCompanyAdmins(): Observable<ApiResponse<CompanyAdmin[]>> {
    return this.apiService.get<CompanyAdmin[]>(this.basePath);
  }

  inviteCompanyAdmin(payload: InviteCompanyAdminPayload): Observable<ApiResponse<CompanyAdmin>> {
    return this.apiService.post<CompanyAdmin>(this.basePath, payload);
  }

  updateCompanyAdmin(
    userId: string,
    payload: Partial<InviteCompanyAdminPayload> & { status?: boolean }
  ): Observable<ApiResponse<CompanyAdmin>> {
    return this.apiService.patch<CompanyAdmin>(`${this.basePath}/${userId}`, payload);
  }

  removeCompanyAdmin(userId: string): Observable<ApiResponse<{ id: string; removed: boolean }>> {
    return this.apiService.delete<{ id: string; removed: boolean }>(`${this.basePath}/${userId}`);
  }
}
